import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import RouteButton from "../RouteButton/RouteButton";
import "./Footer.css";

class Footer extends PureComponent {
  render() {
    let currentYear = new Date().getFullYear();
    return (
      <footer id="footer" className="container-fluidt">
        <div className="col-12 col-xl-10 offset-xl-1" style={{ padding: "0" }}>
          <div className="footerContainer row">
            <div className="footer-col footer-contact col-12 col-md-6 col-xl-3 text-center text-xl-left">
              <h3>Kontakta oss</h3>
              <p>
                <a href="mailto:info@corviva.se">info@corviva.se</a>
                <br />
                <a href="tel:+462319100">023-191 00</a>
              </p>
            </div>
            <div className="footer-col footer-location col-12 col-md-6 col-xl-3 text-center text-xl-left mx-auto">
              <h3>Besöksadress</h3>
              <p>
                <a href="https://www.google.se/maps/place/Kungsgatan+16,+753+32+Uppsala/@59.8621737,17.6354615,17z/data=!3m1!4b1!4m5!3m4!1s0x465fcbf63faa81c3:0xa6127f7d8c082cd0!8m2!3d59.8621737!4d17.6376502">
                  Kungsgatan 16
                  <br />
                  Uppsala
                </a>
              </p>
            </div>
            <div className="footer-col col-12 col-md-6 col-xl-3 text-center footerLinks text-center text-xl-left">
              <div className="row">
                <div className="col-12">
                  <RouteButton
                    className="routeButton"
                    click_function={this.props.click_function}
                    ga_name="Footer"
                    ga_category="Home"
                    buttonText="Hem"
                    linkTo="/"
                  />
            </div>
            <div className="col-12">
                  <RouteButton
                    className="routeButton"
                    click_function={this.props.click_function}
                    ga_name="Footer"
                    ga_category="Services"
                    buttonText="Tjänster"
                    linkTo="/services"
                  />
                </div>
              {/*  <div className="col-12">
                  <RouteButton
                    className="routeButton"
                    click_function={this.props.click_function}
                    ga_name="Footer"
                    ga_category="Career"
                    buttonText="Karriär"
                    linkTo="/career"
                  />
                </div>*/}
                <div className="col-12">
                  <RouteButton
                    className="routeButton"
                    click_function={this.props.click_function}
                    ga_name="Footer"
                    ga_category="Contact"
                    buttonText="Kontakta oss"
                    linkTo="/contact"
                  />
                </div>
              </div>
            </div>
{/*
             <div className="footer-col socialButtons col-12 col-md-6 col-xl-3 text-center text-xl-right">
              <ul className="list-inline">
                <li className="list-inline-item">
                  <SocialButton
                    icon="fa fa-twitter"
                    ga_name="Twitter"
                    ga_category="Social-Media"
                    click_function={this.props.click_function}
                    linkTo="Your Twitter"
                  />
                </li>
                <li className="list-inline-item">
                  <SocialButton
                    icon="fa fa-facebook"
                    ga_name="Facebook"
                    click_function={this.props.click_function}
                    ga_category="Social-Media"
                    linkTo="Your Facebook"
                  />
                </li>
                <li className="list-inline-item lastSocialChild">
                  <SocialButton
                    icon="fa fa-linkedin"
                    ga_name="Linkedin"
                    ga_category="Social-Media"
                    click_function={this.props.click_function}
                    linkTo="Your Linkedin"
                  />
                </li>
              </ul>
              </div>
*/}
          </div>
          <hr />
          <div className="footer-below col-12 text-center text-xl-left">
            Copyright <i className="fa fa-copyright" aria-hidden="true" />
            { " Corviva " + currentYear}
          </div>
        </div>
      </footer>
    );
  }
}

Footer.propTypes = {
  click_function: PropTypes.func
};

Footer.defaultProps = {
  click_function: () => {}
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx